import classNames from 'classnames';
import React, { useLayoutEffect, useRef } from 'react';
import { useLabelWidth } from 'sharedreact/components/private/ParameterGroupProvider';

type Props = {
  className?: string,
  labelClassName?: string,
  inputId?: string,
  label: string,
  labelTooltip?: string,
  children?: React.ReactNode,
  inputContainer?: boolean,
  disabled?: boolean
};

function ParameterComponent ({
  className, labelClassName, inputId,
  label, labelTooltip, children,
  inputContainer = true, disabled
}: Props) {
  const [labelWidth, setLabelWidth] = useLabelWidth();

  const labelRef = useRef<HTMLLabelElement>(null);

  const renderedInput = inputContainer
    ? <div className='esko_forminput'>{children}</div>
    : children;

  type ChildWithProps = typeof children & {props?: {disabled?: boolean} };

  const childrenDisabled: boolean = children != null && (children as ChildWithProps).props != null && (children as ChildWithProps).props.disabled === true;

  useLayoutEffect(() => {
    if (labelRef.current != null) {
      const width = labelRef.current.offsetWidth;
      if (width > labelWidth) {
        setLabelWidth(width);
      }
    }
  });

  return (
    <div className={classNames('form-group', 'esko_formrow', className)}>
      <label htmlFor={inputId} title={labelTooltip}
        className={classNames('esko_control-label esko_formlabel', {'esko_formlabel_disabled': childrenDisabled || disabled === true}, labelClassName)}
        style={{minWidth: labelWidth}}
        ref={labelRef}
      >
        {label}
      </label>
      {renderedInput}
    </div>
  );
}

export default ParameterComponent;
